import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Loader } from 'shared-components';
import { FormattedMessage } from 'react-intl';

const PAGE = 'tax-documents';
const apiUrl = (year) => `/api/v1/cardholder_portal/cardholder/t4a/${year}`;

const TaxDocumentViewer = () => {
  const { year } = useParams();
  const [loaded, setLoaded] = useState(false);
  const [ready, setReady] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const checkPdf = async () => {
      try {
        const response = await fetch(apiUrl(year));

        if (!response.ok) {
          const contentType = response.headers.get('content-type') || '';
          if (contentType.includes('application/json')) {
            const body = await response.json();
            const code = body?.error?.code || '';
            setError(code === 't4a_document_not_found' ? 'not_found' : 'generic');
          } else {
            setError('generic');
          }
          return;
        }

        setReady(true);
      } catch {
        setError('generic');
      }
    };

    checkPdf();
  }, [year]);

  document.title = `T4A_${year}.pdf`;

  if (error) {
    return (
      <div
        style={{
          backgroundColor: '#fff',
          minHeight: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <h2 style={{ marginBottom: '12px', color: '#333' }}>
            {error === 'not_found' ? (
              <FormattedMessage
                id={`${PAGE}-not-found-heading`}
                defaultMessage="Tax Document Not Available"
              />
            ) : (
              <FormattedMessage
                id={`${PAGE}-error-heading`}
                defaultMessage="Something Went Wrong"
              />
            )}
          </h2>
          <p style={{ color: '#666', fontSize: '14px' }}>
            {error === 'not_found' ? (
              <FormattedMessage
                id={`${PAGE}-not-found-message`}
                defaultMessage="The T4A document for {year} is not yet available. Please check back later."
                values={{ year }}
              />
            ) : (
              <FormattedMessage
                id={`${PAGE}-download-error`}
                defaultMessage="Failed to download tax document. Please try again later."
              />
            )}
          </p>
        </div>
      </div>
    );
  }

  if (!ready) {
    return (
      <div
        style={{
          backgroundColor: '#fff',
          minHeight: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Loader />
      </div>
    );
  }

  return (
    <>
      {!loaded && (
        <div
          style={{
            backgroundColor: '#fff',
            minHeight: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Loader />
        </div>
      )}
      <iframe
        src={apiUrl(year)}
        title={`T4A_${year}.pdf`}
        onLoad={() => setLoaded(true)}
        style={{
          width: '100%',
          height: '100vh',
          border: 'none',
          margin: 0,
          padding: 0,
          display: loaded ? 'block' : 'none',
        }}
      />
    </>
  );
};

export default TaxDocumentViewer;
